var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-twitch';
                    var viewUrl = 'sprite.svg#view-logo-twitch';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-twitch#logo-twitch';
                            viewUrl = 'sprite.svg?logo-twitch#view-logo-twitch';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 256 268',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };